import React from 'react';
import PropTypes from 'prop-types';
import IconCollection from "../../IconCollection/IconCollection";

const DateNavigation = ({ previousDay, nextDay, formattedDate }) => {
  return (
    <div id="oneDayDate" className="flex items-center gap-3 md:gap-2 lg:gap-6">
      <button onClick={previousDay}>
        <IconCollection name="arrow_left_border" />
      </button>
      <p className="uppercase font-bebas text-2xl sm:text-4xl text-dark">
        {formattedDate == 'undefined' ? "No Date Selected" : formattedDate}
      </p>
      <button onClick={nextDay}>
        <IconCollection name="arrow_right_border" />
      </button>
    </div>
  );
};

DateNavigation.propTypes = {
  previousDay: PropTypes.func.isRequired,
  nextDay: PropTypes.func.isRequired,
  formattedDate: PropTypes.string.isRequired,
};

export default DateNavigation;